import http from '../util/axios'
import config from '../../config/endpoints.js'
//  Default BASE API URL
const API_URL = config.chs_url;
const STATIC_URL = config.oh_url;
const PH_URL = config.ph_url;
/**
 * @description Api Service Module
 * @author Fahid Mohamamd
 * @date 21-12-2018
 */
const API = {
   getStaticData: function (param, uid, stid, eid, callback) {
      let requestData = { "mtype": param }
      if (uid) { requestData.utid = uid }
      if (requestData.utid=='1') { requestData.stid = stid }
      if (eid) { requestData.eid = eid }
      http.post(API_URL + '/general/getStaticData', requestData).then(response => {
         const { status, data } = response
         let responseObject = { status: status, data: null }
         if (status === 1000) {
            if (typeof data === 'object') {
               responseObject.data = data
            }
         }
         return callback(responseObject)
      })

   },
   getMenuData: function (param, callback) {
      http.post(API_URL + '/menu', param).then(response => {
         return callback(response)
      })
   },
   getBupaAbandonedId: function (param, callback) {
      http.post(API_URL + '/bupa/prebookid', param).then(response => {
         return callback(response)
      })
   },
   getBupaAppointmentId: function (param, callback) {
      http.post(API_URL + '/bupa/id', param).then(response => {
         return callback(response)
      })
   },
   getPharmform: function (param, callback) {
      http.post(API_URL + '/bupa/prescription/data', param).then(response => {
         return callback(response)
      })
   },
   addPriscription: function (param, callback) {
      http.post(API_URL + '/bupa/drugsList', param).then(response => {
         return callback(response)
      })
   },
   getPriscription: function (callback) {
      http.get(API_URL + '/bupa/getPrescriptionMasterData').then(response => {
         return callback(response)
      })
   },
   medicalProblems: function (callback) {
      http.get(API_URL + '/bupa/medicalProblems').then(response => {
         return callback(response)
      })
   },
   manualprofile:function(param, callback){
      http.post(PH_URL + '/v5/manual/profile', param).then(response => {
         return callback(response)
      })
   },
   getDepartmentList: function (callback) {
      http.get(API_URL + '/bupa/departments').then(response => {
         return callback(response)
      })
   },
   forgotpwd: function (param, callback) {
      http.post(API_URL + '/employee/forgotPassword', param).then(response => {
         return callback(response)
      })
   },
   getBupaAppointments: function (param, callback) {
      http.post(API_URL + '/bupa/refillist', param).then(response => {
         return callback(response)
      })
   },
   getBupaAdandoned: function (param, callback) {
      http.post(API_URL + '/bupa/prebooklist', param).then(response => {
         return callback(response)
      })
   },
   getbookingCountries: function (callback) {
      http.get(API_URL + '/general/bookingCountries').then(response => {
         return callback(response)
      })
   },
   provoderList: function(param,callback) {
      http.post(STATIC_URL + '/general/getStaticData',param).then(response => {
         return callback(response)
      })
   },
   bookBupa: function (param, callback) {
      http.post(API_URL + '/bupa/book', param).then(response => {
         return callback(response)
      })
   },
   getBupaSlots: function (param,callback) {
      http.post(API_URL + '/bupa/slots', param).then(response => {
         return callback(response)
      })
   },
   searchPatient: function (param,callback) {
      http.post(API_URL + '/bupa/patientDetails',param).then(response => {
         return callback(response)
      })
   },
      getPharmacyList: function (callback) {
      http.get(API_URL + '/bupa/pharmacyList').then(response => {
         return callback(response)
      })
   },
   getCityData: function (param, callback) {
      http.post(API_URL + '/general/getStaticData', param).then(response => {
         return callback(response)
      })

   },
   addSchedule: function (param, callback) {
      http.post(API_URL + '/bupalabschedules/add', param).then(response => {
         return callback(response)
      })

   },
   getScheduleList: function (param, callback) {
      http.post(API_URL + '/bupalabschedules/list', param).then(response => {
         return callback(response)
      })

   },
   editScheduleData: function (param, callback) {
      http.post(API_URL + '/bupalabschedules/id', param).then(response => {
         return callback(response)
      })

   },
   updateScheduleData: function (param, callback) {
      http.post(API_URL + '/bupalabschedules/edit', param).then(response => {
         return callback(response)
      })

   },
   deleteScheduleData: function (param, callback) {
      http.post(API_URL + '/bupalabschedules/updateStatus', param).then(response => {
         return callback(response)
      })

   },
   saveBupaLabSanarNote : function(params, callback){
      http.post(API_URL + '/bupalabschedules/sanarnotes', params).then(response => {
         return callback(response)
      })
   },
}
export default API



// WEBPACK FOOTER //
// ./src/services/api.js